import { Component, Input } from '@angular/core';
import { Step } from './Step';

@Component({
  selector: 'sts-wizard',
  templateUrl: './wizard.component.html'
})
export class WizardComponent {
  stepArray: Step[] = [];
  stepCount: number;
  @Input() activeStep: number;
  @Input()
  get stepData(): Step[] {
    return this.stepArray;
  }
  set stepData(stepData: Step[]) {
    this.getWizardSteps(stepData);
  }

  constructor() { }

  getWizardSteps(stepData: Step[]) {
    this.stepArray = [];
    for (let i = 0; i < stepData.length; i++) {
      if (stepData[i].stepName !== undefined) {
        this.stepArray.push({ stepNum: i + 1, stepName: stepData[i].stepName });
      } else {
        this.stepArray.push({ stepNum: i + 1, stepName: '' });
      }
    }
    this.stepCount = this.stepArray.length;
  }

  getProgressTrackerClass(step: Step) {
    if (step.stepNum < this.activeStep) {
      return 'progTracker-done';
    } else if (step.stepNum === this.activeStep) {
      return 'progTracker-active';
    } else {
      return 'progTracker-todo';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/wizard/wizard.component.ts